import { render, staticRenderFns } from "./four.vue?vue&type=template&id=ba74cfe4&scoped=true"
import script from "./four.vue?vue&type=script&lang=js"
export * from "./four.vue?vue&type=script&lang=js"
import style0 from "./four.vue?vue&type=style&index=0&id=ba74cfe4&prod&lang=less"
import style1 from "./four.vue?vue&type=style&index=1&id=ba74cfe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba74cfe4",
  null
  
)

export default component.exports